/**
****************************************************************************************
Project: Readabl
File: DisabledLayer.js
Description: This component will render disabled layer.
© Healthcare Triangle, Inc
****************************************************************************************
**/

import { CheckCircle, RadioButtonUnchecked } from "@mui/icons-material";
import React from "react";

const DisabledLayer = (props) => {
    return (
        props.disabled ? <div 
            className="pdf-viewer-disabled-container" 
            key={props.page}
                style={{
                    width: props?.imageDimensions?.width,
                    height: props.imageDimensions?.height,
            }}
            >
            {props.disabledText ? <div className="pdf-viewer-disable-text">{props.disabledText}</div> : null}

        </div> : null

    )
}

export default DisabledLayer;